import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error Untyped import
import { getHomesFeedbackSurvey } from '../../utils/reportingIAUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackLink = ({
  feedbackClient
}) => {
  const surveyId = getHomesFeedbackSurvey();
  return /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.collectionHomes.feedback.question"
    }), ' ', /*#__PURE__*/_jsx(Link, {
      onClick: () => feedbackClient && feedbackClient.loadSurvey('CSAT', surveyId),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.collectionHomes.feedback.link"
      })
    })]
  });
};
export default FeedbackLink;